import React from 'react';
import { IconExclamationTriangle } from '../ui-kit/icons';
import ScheduleWarning from '../schedule/ScheduleWarning';
import { Badge } from '../ui-kit';
import DetailsPopover from './DetailsPopover';
import { isEmpty } from 'lodash';

const GroupName = props => (
  <h3 size={props.size} className="d-inline fw-semibold">
    <Badge variant="secondary">{props.children}</Badge>
  </h3>
);

const Incident = props => (
  <h4 className="mt-1 mb-0">
    <a href={`/activity_reports/${props.incident.id}`} target="_blank" rel="noreferrer">
      <Badge variant="primary">{props.incident.body}</Badge>
    </a>
  </h4>
);

const FullStationDetails = props => (
  <div className="station-warnings">
    <GroupName>
      <a href={`/groups/${props.group.id}`} target="_blank" style={{ color: '#fff' }} rel="noreferrer">
        {!isEmpty(props.incidents) && (
          <IconExclamationTriangle className="fa-beat-fade d-inline-block mt-1 me-1 text-warning" />
        )}
        {props.group.short_code ? props.group.short_code : props.group.name}
      </a>
    </GroupName>
    <div className="in-map">
      {!isEmpty(props.incidents) &&
        Object.values(props.incidents).map(incident => (
          <Incident key={incident.id} group={props.group.id} incident={incident} />
        ))}
      {props.group.availability_requirements.map((ar, index) => (
        <DetailsPopover
          key={ar.id}
          availabilityRequirements={[ar]}
          availabilityRequirementState={props.availabilityRequirementState}
          skills={props.skills}
        >
          <div>
            <ScheduleWarning
              key={ar.id + index}
              size="large"
              availabilityRequirementState={props.availabilityRequirementState[ar.id]}
              availabilityRequirement={ar}
            />
          </div>
        </DetailsPopover>
      ))}
    </div>
  </div>
);

export default FullStationDetails;
